/**
 * Custom error class for connectivity/access issues
 * Thrown when API requests fail due to network connectivity, firewall, VPN, or access problems
 */
export class ConnectivityError extends Error {
  public readonly originalError: Error

  constructor(originalError: Error) {
    super("Network connectivity issue - unable to access resource")
    this.name = "ConnectivityError"
    this.originalError = originalError

    // This is needed to make instanceof work correctly with TypeScript
    Object.setPrototypeOf(this, ConnectivityError.prototype)
  }
}
